import { Backdrop, Box, CircularProgress } from "@mui/material"
import NapaLogo from '../../assets/napa_logo.png'
import { LoadingOverlayStyles } from "./LoadingOverlayStyles"

type OverlayProps = {
    isLoading: boolean
}

const LoadingOverlay = ({ isLoading }: OverlayProps) => {
    return (
        <Backdrop
            sx={LoadingOverlayStyles.backdrop}
            open={isLoading}>
            <Box sx={LoadingOverlayStyles.container}>
                <CircularProgress size={100} thickness={2} sx={LoadingOverlayStyles.circularProgress} />
                <Box
                    component='img'
                    src={NapaLogo}
                    alt='Loading'
                    sx={LoadingOverlayStyles.image}
                />
            </Box>
        </Backdrop>
    )
}

export default LoadingOverlay
